import { NgModule } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { EmployeeService } from '../../services/employee.service';
import { IEmployee } from '../../model/employee'
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { AnalyticsService } from '../../services/analytics.service';
import { menurolesService } from '../../services/menuroles.service';

@Component({
    selector: 'app-employee-list',
    templateUrl: './employee-list.component.html',
    styleUrls: ['./employee-list.component.scss']

})


export class EmployeeListComponent implements OnInit {
    isPageEditable: boolean = false;
    selectedview: number;
    loginUser: any;
    employees: Observable<any>;
    employee: Observable<any>;
    selectedDoctor: Observable<any>;
    statusMessage: string = "Loading data please wait...";
    isSlide: boolean = false;
    constructor(private _employeeService: EmployeeService, private router: Router, private _analyticsService: AnalyticsService, private _menurolesService: menurolesService) {

        this.selectedview = 0;
    }
    ngOnInit() {

        const $ = window["$"];
        function toggleIcon(e) {
            $(e.target)
                .prev('.panel-heading')
                .find(".more-less")
                .toggleClass('glyphicon-plus glyphicon-minus');
        }
        $('.panel-group').on('hidden.bs.collapse', toggleIcon);
        $('.panel-group').on('shown.bs.collapse', toggleIcon);
        this.getDoctorList();
        this.loginUser = JSON.parse(localStorage.getItem('currentUser'));
        this.isPageEditable = this._menurolesService.getpageAcessbility()
    }

    selectName(event) {
        this.selectedview = event;
    }

   
    parseDate(str) {
        var mdy = str.split('/');
        return new Date(mdy[2], mdy[0]-1, mdy[1]);
    }
    
    datediff(first, second) {
        // Take the difference between the dates and divide by milliseconds per day.
        // Round to nearest whole number to deal with DST.
        return Math.round((second-first)/(1000*60*60*24));
    }



    //add the daysDifference in the doctorList
    addDaysDifference(employeeList){
        console.log('test ', employeeList);
        let empList : any = [];
        let now = new Date();
        let currentDate = (now.getMonth()+1)+'/'+now.getDate()+'/'+now.getFullYear();
        for(let index = 0;index<employeeList.length;index++){
            if(employeeList[index].licenseTillDate){
                employeeList[index].expiredIn = this.datediff(this.parseDate(currentDate),this.parseDate(employeeList[index].licenseTillDate)); 
                empList[index] = employeeList[index];
            }
            else{
                employeeList[index].expiredIn = null;
                empList[index] = employeeList[index];
            }

            if(employeeList[index].profileImage.includes(employeeList[index].id)){
                employeeList[index].employeeProfileImage = employeeList[index].profileImage;
            }
            else{
                employeeList[index].employeeProfileImage = null;
            }
           
        }
        return empList;
    }


    //method to verify the Doctors License 
    verifyLicense(doctorId: any, licenseValue: boolean){
        this._employeeService.approveDoctorLicense(doctorId,licenseValue).subscribe((data: any)=>{
            console.log('subscribe data ', data);
            this.getDoctorList();
        })
    }


    getDoctorList() {
        this._employeeService.getDoctors()
            .subscribe(
                (employeeData) => {
                    if (employeeData == null) {
                        this.statusMessage = "Employee Id does not exist..";
                    }
                    else {
                        this.employees = this.addDaysDifference(employeeData.response.doctotList);
                    }
                    console.log('doctors List',this.employees);
                },
                (error) => {
                    this.statusMessage = "Problem with the service. Please try again after sometime";
                    console.log(error);
                }

            );
    }

    verifyEmployee(emp) {
        let confimationMessage = emp.isVerified == true ? "Are you sure want to UnApprove " + emp.name : "Are you sure want to Approve " + emp.name;
        if (confirm(confimationMessage)) {
            console.log("Implement delete functionality here");
            this._employeeService.verifyEmployee(emp).subscribe(
                data => {
                    if (data.returnCode == 0) {
                        alert("Record updated sucessfully")
                        this.getDoctorList();
                    }
                    else {
                        alert(data.returnMsg)

                    }
                },
                error => {
                    // this.alertService.error(error);
                    // this.loading = false;         
                    alert(error)
                    console.log(error)
                });

        }
        else {
            this.getDoctorList();
        }
    }

    redirctdoctorslots(emp) {
        this._employeeService.setEmpleeData(emp);
        this.router.navigate(['/doctorslots']);
    }

    redirctEditpage(emp) {
        var empdetils = this.getEmpleeProfile(emp);
    }

    getEmployeeProfile(empid) {
        this.router.navigate(['/employeeProfile']);
    }


    getEmpleeProfile(data) {
        this._employeeService.getEmployeedetails(data)
            .subscribe(
                (employeeData) => {
                    if (employeeData == null) {
                    }
                    else {
                        this.employee = employeeData.response.doctotdetails;
                        this._employeeService.setEmpleeData(this.employee);
                        this.router.navigate(['/EditDoctor']);
                    }
                    console.log(this.employee);
                },
                (error) => {

                    console.log(error);
                }

            );

    }
    onSearchChange(searchValue: string) {
        console.log('searchvalue ', searchValue);
        if(searchValue){
            this._analyticsService.searchDoctors(searchValue, 2)
            .subscribe(
                (employeeData) => {
                    if (employeeData == null) {
                        this.statusMessage = "Employee Id does not exist..";
                    }
                    else {
                        this.employees = employeeData.response.doctotList
                    }
                },
                (error) => {
                    this.statusMessage = "Problem with the service. Please try again after sometime";
                    console.log(error);
                }
            );
        }
        else{
            console.log('else block');
            this.getDoctorList();
        }
        

    }

    deleteEmployee(emp) {
        let confimationMessage = "Are you sure want to Delete " + emp.name;
        if (confirm(confimationMessage)) {
            console.log("Implement delete functionality here");
            this._employeeService.deleteEmployee(emp).subscribe(
                data => {
                    if (data.returnCode == 0) {
                        alert("Record Deleted sucessfully")
                        this.getDoctorList();
                    }
                    else {
                        alert(data.returnMsg)

                    }
                },
                error => {
                    alert(error)
                    console.log(error)
                });

        }
    }

    updateEmployeeStatus(emp) {
        let confimationMessage = emp.doctorAvailability == true ? "Are you sure want to Logout " + emp.name : "Are you sure want to make " + emp.name + " available";

        if (confirm(confimationMessage)) {
            console.log("Implement delete functionality here");
            this._employeeService.updateEmployeeloginStatus(emp).subscribe(
                data => {
                    if (data.returnCode == 0) {
                        alert("Record updated sucessfully")
                        this.getDoctorList();
                    }
                    else {
                        alert(data.returnMsg)

                    }
                },
                error => {
                    alert(error)
                    console.log(error)
                });

        }
    }

    sideBarToggle() {
        if (this.isSlide) {
            this.isSlide = false;
        }
        else {
            this.isSlide = true;
        }

    }
}



// WEBPACK FOOTER //
// ./src/app/admin/employee-list/employee-list.component.ts